import { ThemeName } from 'models/theme';

// eslint-disable-next-line @typescript-eslint/comma-dangle
export const randomShuffle = <T,>(arr: T[]): T[] => {
  return [...arr].sort(() => 0.5 - Math.random());
};

export const sortByPos = <T extends { position: number | null }>(arr: T[]): T[] => {
  return [...arr].sort((a, b) => Number(a.position) - Number(b.position));
};

export const isEmptyObject = (object: {}) => (JSON.stringify(object) === '{}');

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

//Theme hotfix for now, change when we fix js theme loading
export const getStripedRowColor = (): string => {
  const dataTheme = $("html").data("theme");
  if (dataTheme === ThemeName.DARK) {
    return '#01223d';
  } else if (dataTheme === ThemeName.LIGHT) {
    return '#f5f6f7';
  } else if (dataTheme === ThemeName.DIMMED) {
    return '#e5e5e5';
  } else if (dataTheme === ThemeName.BLACK) {
    return '#151515';
  } else {
    return '#f5f6f7';
  }
  };

//Only if we don't support expansion
export const getStripedRowsForTable = () : any => {
  return {
    '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
      {
        backgroundColor: getStripedRowColor(),
      },
      '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
      {
        backgroundColor: 'inherit',
      },
    '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
      {
        backgroundColor: 'inherit',
      },
    };
};

//Only if we do support expansion
export const needsOverrideColorForExpansion = (row: any): boolean =>  {
  if (!row) return false
  //not expanded
  if (row && row.depth === 0) {
      const getIndex = row.index
    if (getIndex % 2 === 0) {
      return false
    } else {
      return true
    }
  }

  if (row && row.depth !== 0) { 
    const getIndex = row.getParentRow().index
    if (getIndex % 2 === 0) {
      return false
    } else {
      return true
    }
  }

  return false
}

//Only if we do support expansion
export const getStripedRowsForExpansion = (row: any): string =>  {
  return needsOverrideColorForExpansion(row) ? getStripedRowColor() : 'inherit'
}

const getSecondaryStripedRowColor = (): string => {
  const dataTheme = $("html").data("theme");
  if (dataTheme === ThemeName.DARK) {
    return '#023b69';//01223d
  } else if (dataTheme === ThemeName.LIGHT) {
    return '#dadde1';//f5f6f7
  } else if (dataTheme === ThemeName.DIMMED) {
    return '#cecece';//e5e5e5
  } else if (dataTheme === ThemeName.BLACK) {
    return '#2c2c2c';//151515
  } else {
    return '#dadde1';//f5f6f7
  }
};

export const getSecondaryStripedRowsForExpansion = (row: any): string =>  {
  if (needsOverrideColorForExpansion(row)) {
    return getSecondaryStripedRowColor()
   } else {
      const dataTheme = $("html").data("theme");
      //dark lighten 10%, light darken 10%
      if (dataTheme === ThemeName.DARK) {
        return '#012745';//012b4d
      } else if (dataTheme === ThemeName.LIGHT) {
        return '#e6e6e6';//fff
      } else if (dataTheme === ThemeName.DIMMED) {
        return '#d3d3d3';//ebebeb
      } else if (dataTheme === ThemeName.BLACK) {
        return '#1a1a1a';//000
      } else {
        return '#e6e6e6';//fff
      }
   }
}